module.exports = __webpack_public_path__ + "img/zaixiankefu.41f79f71.png";